import * as React from 'react';
import { TableMapper } from '../../../shared';
export var TableFooterCellsMapperBase = function () { return (React.createElement(TableMapper, { rampName: "FooterCellBase" })); };
